// ===== YUMYUM story motion (loaded ONLY on legacy / our-story templates) =====
// Decoration only: if GSAP fails to load, the pages render fully static.
// All initial hidden states are set by GSAP itself — CSS never hides content.
(function(){
'use strict';
if (!window.gsap || !window.ScrollTrigger) return;
gsap.registerPlugin(ScrollTrigger, window.SplitText || {});

const mm = gsap.matchMedia();
mm.add('(prefers-reduced-motion: no-preference)', () => {
  const ready = (document.fonts && document.fonts.ready) ? document.fonts.ready : Promise.resolve();
  ready.then(init);

  function init(){
    // ---- Hero: headline words rise, intro follows ----
    const heroH1 = document.querySelector('.page-hero h1');
    if (heroH1 && window.SplitText){
      const split = SplitText.create(heroH1, { type: 'words' });
      gsap.from(split.words, { y: 26, opacity: 0, duration: .7, ease: 'power3.out', stagger: .06 });
      const heroP = document.querySelector('.page-hero p');
      if (heroP) gsap.from(heroP, { y: 18, opacity: 0, duration: .6, ease: 'power2.out', delay: .45 });
    }

    // ---- Danny's quote: reads in word by word as you scroll ----
    const quote = document.querySelector('.legacy-quote blockquote');
    if (quote && window.SplitText){
      const qs = SplitText.create(quote, { type: 'words' });
      gsap.set(qs.words, { opacity: .14 });
      gsap.to(qs.words, { opacity: 1, ease: 'none', stagger: .4,
        scrollTrigger: { trigger: quote, start: 'top 82%', end: 'bottom 60%', scrub: true } });
      const cite = document.querySelector('.legacy-quote cite');
      if (cite) gsap.from(cite, { opacity: 0, y: 10, duration: .6,
        scrollTrigger: { trigger: quote, start: 'bottom 70%', toggleActions: 'play none none reverse' } });
    }

    // ---- Timeline: red line draws over the gold; items + year badges enter ----
    const tl = document.querySelector('.timeline');
    if (tl){
      const draw = document.querySelector('.tl-draw');
      if (draw) gsap.to(draw, { scaleY: 1, ease: 'none',
        scrollTrigger: { trigger: tl, start: 'top 72%', end: 'bottom 65%', scrub: .5 } });
      gsap.utils.toArray('.tl-item').forEach(item => {
        gsap.from(item, { x: -22, opacity: 0, duration: .55, ease: 'power2.out',
          scrollTrigger: { trigger: item, start: 'top 85%' } });
        const yr = item.querySelector('.tl-year');
        if (yr) gsap.from(yr, { scale: .6, opacity: 0, duration: .5, ease: 'back.out(2)',
          scrollTrigger: { trigger: item, start: 'top 85%' } });
      });
    }

    // ---- Gentle parallax on story imagery (first img only — spares the rotated seal) ----
    gsap.utils.toArray('.s-media img:first-child, .memorial-photo').forEach(img => {
      gsap.fromTo(img, { yPercent: -5 }, { yPercent: 5, ease: 'none',
        scrollTrigger: { trigger: img, start: 'top bottom', end: 'bottom top', scrub: true } });
    });
  }
});
})();
